import {
  DefaultButton,
  IContextualMenuProps,
  Stack,
  Text,
  mergeStyles,
} from "@fluentui/react";
import { CSSProperties, FC, useEffect, useMemo, useState } from "react";
import { TooltipHost } from "@fluentui/react";
import { HorizontalStack, VerticalStack } from "../../Stack";
import { BackButton } from "../../BackButton";
import { ProjectInCard } from "../ProjectInCard";
import { UserModel } from "../../../models";
import { useNavigate, useParams } from "react-router-dom";
import { colorPallete } from "../../../assets/color";
import "./index.css";
import { useTranslation } from "react-i18next";
import { getColor, getFullName } from "../../../utils";
import { useAppSelector } from "../../../hooks/hooks";
import useModal from "../../../hooks/useModal";
import { ProjectService } from "../../../services/ProjectService";
import CustomToggle from "../../CustomToggle";
import Loader from "../../Loader";

const styles = {
  counterPartyLogo: {
    height: "1.6rem",
    minWidth: "1.6rem",
    backgroundColor: colorPallete.btBlue,
    borderRadius: "16px",
    alignItems: "center",
    justifyContent: "center",
  },
  membersLogo: {
    height: "28px",
    minWidth: "28px",
    borderRadius: "16px",
    alignItems: "center",
    justifyContent: "center",
  },
  Initial: {
    fontSize: "10px",
    lineHeight: "16px",
    color: "#F4F4F4",
    fontFamily: "Poppins",
  },
  text: {
    // paddingLeft: "5%",
    fontSize: "12px",
    lineHeight: "20px",
    fontWeight: "400",
    color: colorPallete.black1,
    paddingRight: "2%",
    width: "max-content",
    fontFamily: "Poppins",
  },

  counterParty: {
    paddingLeft: "5%",
    fontSize: "10px",
    lineHeight: "16px",
    fontWeight: "400",
    color: colorPallete.black1,
    paddingRight: "2%",
    width: "max-content",
    fontFamily: "Poppins",
  },
  counterPartyObject: {
    marginLeft: "1%",
    marginRight: "0.25%",
    marginTop: "0.5%",
    border: "1px solid #D0D5DD",
    borderRadius: "4px",
    padding: "4px 10px 4px 4px",
    overflow: "hidden",
    height: "40px",
    backgroundColor: "",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  counterPartiesContainer: {
    display: "flex",
    width: "100%",
    overflow: "auto",
    height: "100%",
    backgroundColor: "",
  },
  descriptionStack: {
    width: "100%",
    alignSelf: "flex-end",
    marginBottom: "1%",
    padding: "1% 0%",
  },
  horizontalLine: {
    width: "100%",
    height: "2px",
    backgroundColor: colorPallete.grey2,
    alignSelf: "center",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    alignItems: "center",
    paddingTop: "10%",
  },
  bodyStyles: {
    fontSize: "15px",
    color: colorPallete.grey1,
    alignSelf: "flex-end",
    fontFamily: "Poppins",
  },
  projectOwnerStack: {
    width: "100%",
    alignSelf: "flex-end",
    marginTop: "1%",
    marginBottom: "1%",
    alignItems: "center",
  },
  textHead: {
    marginTop: "1%",
    fontWeight: 500,
    fontSize: "15px",
    minWidth: "8.5rem",
    width: "fit-content",
    color: colorPallete.grey1,
    fontFamily: "Poppins",
    lineHeightL: "20px",
  },
  textTail: {
    fontWeight: 500,
    fontSize: "15px",
    marginTop: "1%",
    fontFamily: "Poppins",
  },
  projectOwnerText: {
    marginRight: "1%",
    marginTop: "0.5%",
    padding: "0.5%",
    borderRadius: "1rem",
    fontFamily: "Poppins",
  },
  memberText: {
    width: "100%",
    alignSelf: "flex-end",
    justifyContent: "center",
    marginTop: "0.25%",
    fontFamily: "Poppins",
  },

  membersContainer: {
    display: "flex",
    width: "100%",
    overflow: "auto",
    marginLeft: "0.8%",
    height: "calc(46px * 2 + 15px)",
  },
  membersOfProject: {
    padding: "4px 4px 4px 7px",
    overflow: "hidden",
    borderRadius: "5px",
    border: "1px solid #DAE0EC",
    background: "linear-gradient(270deg, rgba(239, 236, 249, 0.60) 0%, rgba(236, 240, 249, 0.60) 100%)",
    height: "fit-content",
  },
};

export const ProjectDetailsCard: FC<any> = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [workingGroups, setWorkingGroups] = useState<UserModel[]>([]);
  const [projectOwners, setProjectOwners] = useState<UserModel[]>([]);
  const user = useMemo(() => {
    const userStr = localStorage.getItem("user");
    return userStr ? JSON.parse(userStr) : null;
  }, []);
  const getWorkingGroup = useAppSelector(
    (state: { getWorkingGroup: any }) => state.getWorkingGroup
  );
  const [projectCloseAction, setProjectCloseAction] = useState("Active");
  const [isOwner, setIsOwner] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  useEffect(() => {
    if (props.active === null) {
      // props.setIsLoading(true);
    }
  }, [props.active]);
  const dedupeUsers = (users: UserModel[] = []) => {
    const seen = new Set<string>();
    return users.filter((member) => {
      if (!member?.email) {
        return false;
      }
      const key = member.email.toLowerCase();
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });
  };

  useEffect(() => {
    if (getWorkingGroup.data) {
      const workingGroupMembers = dedupeUsers(
        getWorkingGroup.data.workingGroup
      );
      const ownerMembers = dedupeUsers(getWorkingGroup.data.projectOwners);
      setWorkingGroups(
        workingGroupMembers.length > 0
          ? workingGroupMembers
          : user
          ? [user]
          : []
      );
      setProjectOwners(ownerMembers);
    } else if (user) {
      setWorkingGroups([user]);
      setProjectOwners([]);
    } else {
      setWorkingGroups([]);
      setProjectOwners([]);
    }
  }, [getWorkingGroup.data?.workingGroup, getWorkingGroup.data?.projectOwners, user]);
  let { projectId } = useParams();

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        if (props.projectData) {
          const currentStatus: any = await ProjectService.projectInfo(
            Number(projectId)
          );
          // A project with no status row returns `data: null` — guard the deref so
          // the switch flow doesn't throw (DEX-573). Absent status → not Active.
          props.setActive(
            currentStatus?.data?.status === "Active" ? true : false
          );
        } else {
        }
      } catch (error) {
        console.error("Error fetching status:", error);
      }
      props.setIsLoading(false);
    };

    fetchStatus();
  }, [props.projectId, props.projectData]);

  function click() {
    navigate("/home");
    props.setActive(null);
  }

  const membersJsx = (user: UserModel) => {
    return (
      <Stack
        style={styles.membersOfProject}
        title={getFullName(user)}
        key={user?.email}
      >
        <VerticalStack
          style={{ justifyContent: "space-evenly", width: "fit-content" }}
        >
          <HorizontalStack
            style={{ alignItems: "center", backgroundColor: "" }}
          >
            <Stack
              style={{
                ...styles.membersLogo,
                backgroundColor: getColor(getFullName(user)),
              }}
            >
              <Text style={styles.Initial}>
                {getFullName(user)?.charAt(0)?.toUpperCase()}
              </Text>
            </Stack>
            <VerticalStack style={{marginLeft: "10px", alignItems: "flex-start"}}>
              <Text
                style={{
                  ...styles.text,
                  whiteSpace: "nowrap",
                  fontFamily: "Poppins",
                  paddingRight: "28px",
                }}
              >
                {getFullName(user)}
              </Text>
              <Text
                style={{
                  fontSize: "10px",
                  color: "#707070",
                  lineHeight: "16px",
                  paddingRight: "28px",
                  fontFamily: "Poppins",
                }}
              >
                {user.email}
              </Text>
            </VerticalStack>
          </HorizontalStack>
          
        </VerticalStack>
      </Stack>
    );
  };

  const projectNameStyles = mergeStyles({
    fontSize: "24px",
    fontWeight: 500,
    fontFamily: "Poppins",
  });

  const projectDescriptionStyles = mergeStyles({
    fontSize: "13px",
    fontWeight: 400,
    fontFamily: "Poppins",
    lineHeight: "20px",
    color: colorPallete.grey1,
    marginTop: "8px",
    marginBottom: "15px",
  });

  const ownerListStyles: CSSProperties = {
    ...styles.membersContainer,
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "10px",
    height: "auto",
    overflow: "visible",
  };

  const ownerNamesTooltip =
    projectOwners.length > 0
      ? projectOwners
          .map((owner) => getFullName(owner))
          .filter(Boolean)
          .join(", ")
      : props.projectData?.ownerName;

  const primaryProjectOwnerEmail =
    projectOwners[0]?.email || props.projectData?.ownerEmail || "";

  const menuProps: IContextualMenuProps = {
    items: [
      {
        key: "closeButton",
        text: "Close",
        onClick: closeProject,
      },
      {
        key: "abandonButton",
        text: "Abandon",
        onClick: abandonProject,
      },
    ],
  };

  function closeProject() {
    setProjectCloseAction("Close");
    showModal();
  }
  function abandonProject() {
    setProjectCloseAction("Abandon");
    showModal();
  }

  function handleToggleChange() {
    props.setIsLoading(true);
    const payload = {
      id: props?.projectData?.id,
      status: props.active ? "Closed" : "Active",
      value: props?.projectData?.value,
    };
    props.setActive(!props.active);
    ProjectService.changeStatusOfProject(payload)
      .then((res) => {
        if (res.code === 200) {
          setIsSuccess(true);
          props.showToggleProjectModal();
        } else setIsError(true);
      })
      .catch(() => {
        setIsError(true);
      });
    props.setIsLoading(false);

    hideModal();
  }
  useEffect(() => {
    const currentUserEmail = (user?.email || "").toLowerCase();
    const ownerEmails = projectOwners
      .map((owner) => owner.email?.toLowerCase())
      .filter(Boolean) as string[];

    if (currentUserEmail && ownerEmails.length > 0) {
      setIsOwner(ownerEmails.includes(currentUserEmail));
      return;
    }

    if (currentUserEmail && props.projectData?.ownerEmail) {
      setIsOwner(
        props.projectData.ownerEmail.toLowerCase() === currentUserEmail
      );
      return;
    }

    setIsOwner(false);
  }, [projectOwners, props.projectData?.ownerEmail, user?.email]);
  const { isModalOpen, showModal, hideModal } = useModal();
  return (
    <Stack className="ProjectContainer">
      <VerticalStack className="ProjectCardStack">
        {props.projectData && (
          <ProjectInCard
            project={props?.projectData}
            sender="AllProjects"
            isOwner={isOwner}
            projectOwner={primaryProjectOwnerEmail}
          />
        )}
      </VerticalStack>
      <div className="ProjectDetails">
        <VerticalStack
          style={{ justifyContent: "flex-start", alignItems: "flex-start" }}
        >
          <HorizontalStack
            style={{ width: "100%", justifyContent: "space-between" }}
          >
            <BackButton onClickFunction={click} />
            <TooltipHost
              content={
                "Only project owner is authorized to change project status"
              }
            >
              {props.active !== null && isOwner && (
                <CustomToggle
                  active={props.active}
                  height="20px"
                  width="64px"
                  switchDotHeight="18px"
                  switchDotWidth="18px"
                  borderRadius="12px"
                  customInactiveLeft="1.3%"
                  customActiveLeft="calc(100% - 29.7%)"
                  handleChange={handleToggleChange}
                  redText={"Closed"}
                  blueText={"Active"}
                  data
                  disabled={!isOwner}
                />
              )}
            </TooltipHost>
          </HorizontalStack>
          <HorizontalStack style={{ width: "100%" }}>
            <Text className={projectNameStyles}>
              {props.projectData?.name}
            </Text>
          </HorizontalStack>
          <HorizontalStack style={{ width: "100%" }}>
            <Text className={projectDescriptionStyles}>
              {props.projectData?.description}
            </Text>
          </HorizontalStack>
        </VerticalStack>

        <Stack style={styles.horizontalLine}></Stack>
        <HorizontalStack style={styles.projectOwnerStack} title={ownerNamesTooltip}>
          <Text style={styles.textHead}>{t("project_owners")}:</Text>
          <Stack style={styles.projectOwnerText}>
            {projectOwners.length > 0 ? (
              <Stack style={ownerListStyles}>
                {projectOwners.map((owner) => membersJsx(owner))}
              </Stack>
            ) : (
              <Text
                style={{
                  ...styles.text,
                  whiteSpace: "nowrap",
                  paddingTop: "4%",
                  fontWeight: 600,
                }}
              >
                {props.projectData?.ownerName ||
                  props.projectData?.ownerEmail ||
                  "-"}
              </Text>
            )}
          </Stack>
        </HorizontalStack>
        <HorizontalStack style={styles.memberText}>
          <Text style={styles.textHead}>{t("working_group")}:</Text>
          {/* <Text style={styles.textTail}>:</Text> */}
          <Stack
            style={{
              ...styles.membersContainer,
              flexDirection: "row",
              flexWrap: "wrap",
              overflow: "auto",
              gap: "10px",
            }}
          >
            {workingGroups &&
              workingGroups.length > 0 &&
              workingGroups.map((user: UserModel) => membersJsx(user))}
          </Stack>
        </HorizontalStack>
      </div>
    </Stack>
  );
};
